module.exports = __webpack_public_path__ + "img/logo.cfd3cc13.png";